<template>
    <div class="contenedorGracias">
        <h1>Gracias</h1>
        <p>Hemos recibido su mensaje.</p>
    </div>
</template>
<script>

export default {
    name: "Gracias",
};
</script>